module.exports = __webpack_public_path__ + "static/img/wx-pay.9c0225d3.jpg";